import { supabase } from '../../supabaseClient';
import { seedDefaultAccountPlan } from './accountPlan';

// Apaga os dados financeiros de uma empresa: parcelas, lançamentos, centros
// de custo, bancos e plano de contas — este último é recriado com o padrão
// logo em seguida (regra: o plano padrão sempre existe). Operação destrutiva
// e sem recuperação — chame somente após confirmação explícita do usuário.
//
// A ordem é importante por causa das FKs:
//   Installment → FinancialEntry (deve apagar parcelas antes)
//   FinancialEntry → CostCenter / Bank / AccountPlan (referenciam essas
//   tabelas; apagamos os pais depois para evitar erros de constraint em
//   ambientes onde a FK seja restritiva).
export const resetCompanyFinancialData = async (companyId, userId) => {
  if (!companyId) {
    return { error: new Error('companyId obrigatório') };
  }

  // 1) Buscar IDs dos lançamentos da empresa para apagar as parcelas filhas
  const { data: entries, error: entriesErr } = await supabase
    .from('FinancialEntry')
    .select('id')
    .eq('company_id', companyId);
  if (entriesErr) return { error: entriesErr };

  const entryIds = (entries || []).map((e) => e.id);

  // 2) Apagar parcelas (Installment) das entries da empresa
  if (entryIds.length > 0) {
    const { error: instErr } = await supabase
      .from('Installment')
      .delete()
      .in('financial_entry_id', entryIds);
    if (instErr) return { error: instErr };
  }

  // 3) Apagar lançamentos
  const { error: feErr } = await supabase
    .from('FinancialEntry')
    .delete()
    .eq('company_id', companyId);
  if (feErr) return { error: feErr };

  // 4) Apagar centros de custo
  const { error: ccErr } = await supabase
    .from('CostCenter')
    .delete()
    .eq('company_id', companyId);
  if (ccErr) return { error: ccErr };

  // 5) Apagar bancos
  const { error: bankErr } = await supabase
    .from('Bank')
    .delete()
    .eq('company_id', companyId);
  if (bankErr) return { error: bankErr };

  // 6) Apagar plano de contas e recriar o padrão
  const { error: apErr } = await supabase
    .from('AccountPlan')
    .delete()
    .eq('company_id', companyId);
  if (apErr) return { error: apErr };

  const { error: seedErr } = await seedDefaultAccountPlan({ companyId, userId });
  return { error: seedErr || null };
};
